<section>  
  <div class="row">
    <div class="col-6">
      <div *ngIf="thermalCalculatorResource?.horizontalDlo?.length>0">
        <p [hidden]="thermalCalculatorResource?.horizontalDloTextHide" class="text-center"><strong>{{projectDimentionTxt.horizontalDloLbl?projectDimentionTxt.horizontalDloLbl:projectDimension.horizontalDloLbl}}</strong></p>
        <div class="form-inline col" *ngFor="let item of thermalCalculatorResource?.horizontalDlo; index as i;">
          <div class="input-group p-1">
            <div class="input-group-prepend" *ngIf="item?.name?.length>1">
              <div class="input-group-text">{{item?.name}}</div>
            </div>
            <select class="custom-select" name="{{item?.type}}" [(ngModel)]="item.type" *ngIf="item?.typeOptions?.length>0">
              <option value="0" selected>{{projectDimentionTxt.chooseLbl?projectDimentionTxt.chooseLbl:projectDimension.chooseLbl}}</option>
              <option value="{{op}}" *ngFor="let op of item?.typeOptions;">{{op}}</option>
            </select>
            <input class="form-control" name="{{item?.name}}" [(ngModel)]="item.feet"
                   min="0.00"
                   step="0.01"
                   validate="true"
                   pattern="(^[0-9]{0,2}$)|(^[0-9]{0,2}\.[0-9]{0,5}$)"
                   type="number">
            <div class="input-group-append">
              <div class="input-group-text">{{projectDimentionTxt.ftLbl?projectDimentionTxt.ftLbl:projectDimension.ftLbl}}</div>
            </div>
            <input class="form-control" name="{{item?.name}}" [(ngModel)]="item.inch"
                   min="0.00"
                   step="0.01"
                   validate="true"
                   pattern="(^[0-9]{0,2}$)|(^[0-9]{0,2}\.[0-9]{0,5}$)"
                   type="number">
            <div class="input-group-append">
              <div class="input-group-text">{{projectDimentionTxt.inLbl?projectDimentionTxt.inLbl:projectDimension.inLbl}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-6">
      <div *ngIf="thermalCalculatorResource?.verticalDlo?.length>0">
        <p [hidden]="thermalCalculatorResource?.verticalDloTextHide" class="text-center"> <strong>{{projectDimentionTxt.verticalDloLbl?projectDimentionTxt.verticalDloLbl:projectDimension.verticalDloLbl}}</strong></p>
        <div class="form-inline col" *ngFor="let item of thermalCalculatorResource?.verticalDlo; index as i;">
          <div class="input-group p-1">
            <div class="input-group-prepend" *ngIf="item?.name?.length>1">
              <div class="input-group-text">{{item?.name}}</div>
            </div>
            <select class="form-control" name="{{item?.type}}" [(ngModel)]="item.type" *ngIf="item?.typeOptions?.length>0">
              <option value="0" selected>{{projectDimentionTxt.chooseLbl?projectDimentionTxt.chooseLbl:projectDimension.chooseLbl}}</option>
              <option value="{{op}}" *ngFor="let op of item?.typeOptions;">{{op}}</option>
            </select>
            <input min="0.00"
                   step="0.01"
                   validate="true"
                   pattern="(^[0-9]{0,2}$)|(^[0-9]{0,2}\.[0-9]{0,5}$)"
                   type="number" class="form-control" name="{{item?.name}}" [(ngModel)]="item.feet">
            <div class="input-group-append">
              <div class="input-group-text">{{projectDimentionTxt.ftLbl?projectDimentionTxt.ftLbl:projectDimension.ftLbl}}</div>
            </div>
            <input min="0.00"
                   step="0.01"
                   validate="true"
                   pattern="(^[0-9]{0,2}$)|(^[0-9]{0,2}\.[0-9]{0,5}$)"
                   type="number" class="form-control" name="{{item?.name}}" [(ngModel)]="item.inch">
            <div class="input-group-append">
              <div class="input-group-text">{{projectDimentionTxt.inLbl?projectDimentionTxt.inLbl:projectDimension.inLbl}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</section>
